import { actionTypes } from "./postActions";

const intitialState = {
  rows: [],
  loadingPosts: false,
  filter: {},
  showFormModal: false,
  showImageFormModal: false,
  showTextPostDialog: false,
  count: 0,
  order: "asc",
  orderBy: "createdAt",
  page: 0,
  rowsPerPage: 5,
  backgroundPublishing: false,
};

export default (state = intitialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_FORM:
      return {
        ...state,
        showFormModal: true,
      };
    case actionTypes.SHOW_IMAGE_FORM:
      return {
        ...state,
        showImageFormModal: true,
      };

    case actionTypes.SHOW_TEXT_DIALOG:
      return {
        ...state,
        showTextPostDialog: true,
      };

    case actionTypes.CREATE_INIT:
      return {
        ...state,
        showTextPostDialog: false,
      };
    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        showTextPostDialog: false,
      };
    case actionTypes.CREATE_ERROR:
      return {
        ...state,
        backgroundPublishing: false,
        showFormModal: false,
        showImageFormModal: false,
        showTextPostDialog: false,
      };
    case actionTypes.CLOSE_ALL_FORMS:
      return {
        ...state,
        showFormModal: false,
        showImageFormModal: false,
        showTextPostDialog: false,
      };
    case actionTypes.CREATE_IMAGED_POST_INIT:
      return {
        ...state,
        showFormModal: false,
        showImageFormModal: false,
      };
    case actionTypes.CREATE_IMAGED_POST_SUCCESS:
      return {
        ...state,
        backgroundPublishing: false,
        showFormModal: false,
        showImageFormModal: false,
      };

    case actionTypes.FETCH_INIT:
      return {
        ...state,
        page: action.payload.page,
        rowsPerPage: action.payload.limit,
        order: action.payload.order,
        orderBy: action.payload.orderBy,
        loadingPosts: action.payload.loadingScreen,
      };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        loadingPosts: false,
        rows: action.payload.rows,
        count: action.payload.count,
      };
    case actionTypes.FETCH_ERROR:
      return {
        ...state,
        loadingPosts: false,
      };
    case actionTypes.SET_FILTER:
      return {
        ...state,
        filter: action.payload.filter,
      };

    case actionTypes.SET_PAGE:
      return {
        ...state,
        page: action.payload.page,
      };

    case actionTypes.SET_ORDER:
      return {
        ...state,
        order: action.payload.order,
      };

    case actionTypes.SET_ORDERBY:
      return {
        ...state,
        orderBy: action.payload.orderBy,
      };

    case actionTypes.SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.payload.rowsPerPage,
      };

    case actionTypes.BACKGROUND_PUBLISHING:
      return {
        ...state,
        backgroundPublishing: true,
      };

    default:
      return state;
  }
};
